import React, { useState } from 'react';

const BlogImage = ({ title, imageUrl, size = 'medium' }) => {
    const [hasError, setHasError] = useState(false);

    // Size configurations
    const sizeConfig = {
        large: {
            width: 800,
            height: 400,
            className: "h-[400px] w-full object-cover rounded-lg shadow-lg"
        },
        medium: {
            width: 400,
            height: 200,
            className: "h-[200px] w-full object-cover rounded-lg shadow-md"
        }
    };

    // Get default image based on content type
    const getDefaultImage = (title) => {
        const lowerTitle = title.toLowerCase();
        if (lowerTitle.includes('rag')) return '/images/blog/rag-understanding.jpg';
        if (lowerTitle.includes('business')) return '/images/blog/ai-business.jpg';
        if (lowerTitle.includes('generative')) return '/images/blog/generative-ai-advancements.jpg';
        if (lowerTitle.includes('future')) return '/images/blog/ai-future-work.jpg';
        if (lowerTitle.includes('ethics')) return '/images/blog/ai-ethics.jpg';
        if (lowerTitle.includes('healthcare')) return '/images/blog/ai-healthcare.jpg';
        if (lowerTitle.includes('security')) return '/images/blog/ai-cybersecurity.jpg';
        if (lowerTitle.includes('mission') || lowerTitle.includes('mcp')) return '/images/blog/mcp-future.jpg';
        return '/images/blog/default.jpg';
    };

    const config = sizeConfig[size] || sizeConfig.medium;

    // If there's an error or no image URL, use a default image
    if (hasError || !imageUrl) {
        const defaultImage = getDefaultImage(title);
        return (
            <img
                src={defaultImage}
                alt={title}
                className={config.className}
                onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    setHasError(true);
                }}
            />
        );
    }

    return (
        <img
            src={imageUrl}
            alt={title}
            className={config.className}
            onError={() => setHasError(true)}
        />
    );
};

export default BlogImage; 